

export function logoutOnInactivity(mins:number = 60) {
	if (mins <= 0) return;

	let timeout: number = 0;

	function resetLogoutTimer() {
		clearTimeout(timeout);
		timeout = setTimeout(() => {
			window.location.href = 'logout.do';
		}, mins * 60000);
	}

	['mousemove', 'keydown', 'mousedown', 'touchstart'].forEach(eventName =>
		document.addEventListener(eventName, resetLogoutTimer)
	);
	resetLogoutTimer();
}
